import { Component, OnDestroy, OnInit, effect, inject, signal, untracked } from '@angular/core';
import { Store } from '@ngxs/store';

import { TranslocoModule } from '@jsverse/transloco';
import { GetUnreadNotitications, LoadLatestNotifications } from '@state/notifications/notifications.actions';
import { NotificationsSelector } from '@state/notifications/notifications.selector';
import { NotificationTitlePipe } from '@shared/pipe/notification-title.pipe';
import { NotificationIconComponent } from '@shared/components/notification-icon/notification-icon.component';
import { ButtonCustomComponent } from '@shared/components/button-custom/button-custom.component';
import { StopPropagationDirective } from '@shared/directives/stop-propagation.directive';
import { MatMenuModule } from '@angular/material/menu';
import { NotificationShouldDisplayChip } from '@shared/pipe/notification-shouldDisplayChip.pipe';
import { environment } from '@environment/environment';
//
@Component({
    selector: 'app-notifications-menu',
    templateUrl: './notifications-menu.component.html',
    styleUrls: ['./notifications-menu.component.scss'],
    imports: [
    TranslocoModule,
    NotificationTitlePipe,
    NotificationShouldDisplayChip,
    NotificationIconComponent,
    ButtonCustomComponent,
    StopPropagationDirective,
    MatMenuModule
]
})
export class NotificationsMenuComponent implements OnInit, OnDestroy {
  private store = inject(Store);


  notifications$ = this.store.selectSignal(NotificationsSelector.latestNotifications);
  unreadNotifications$ = this.store.selectSignal(NotificationsSelector.unreadNotifications)

  interval: number;

  // keep previous flattened unread notifications as a signal to compare changes
  private previousUnreadNotifications = signal<string[] | null>(null);



  constructor() {
    // React to signal changes instead of subscribing to an observable
    effect(() => {
      const unreadNotifications = this.unreadNotifications$();
      if (unreadNotifications) {
        let k: keyof typeof unreadNotifications;
        const newUnreadNotifications: string[] = [];
        for (k in unreadNotifications) {
          if (unreadNotifications[k].length > 0) {
            newUnreadNotifications.push(...unreadNotifications[k]);
          }
        }
        const prev = untracked(() => this.previousUnreadNotifications());
        if (this.unreadNotificationsHasChanged(prev, newUnreadNotifications)) {
          this.store.dispatch(new LoadLatestNotifications());
        }
        untracked(() => this.previousUnreadNotifications.set(newUnreadNotifications));
      }
    });
  }

  ngOnInit(): void {
    this.store.dispatch([new LoadLatestNotifications(), new GetUnreadNotitications()]);

    this.interval = window.setInterval(() => {
      this.store.dispatch(new GetUnreadNotitications())
    }, environment.notifications.pollUnreadSeconds * 1000);


  }

  private unreadNotificationsHasChanged(previous: string[] | null, next: string[]) {
    return !!previous && !(previous.length === next.length && next.every(notification => previous.includes(notification)))
  }

  ngOnDestroy(): void {
    if (this.interval) {
			window.clearInterval(this.interval);
		}
  }
}
